// extracted by mini-css-extract-plugin
module.exports = {"statsBanner":"StatsBanner_statsBanner__240mH"};